/**
 * One entry per Rashi: glyph for the picker plus the full "Today's Reading"
 * card content. Lucky numbers follow the sign's ruling planet; colours the
 * traditional association.
 */
export const ZODIAC_SIGNS = [
  {
    key: 'aries',
    glyph: '♈',
    name: 'Aries · Mesha',
    rating: 4.5,
    stats: [
      { label: 'Love', value: 82 },
      { label: 'Career', value: 90 },
      { label: 'Health', value: 68 },
      { label: 'Finance', value: 75 },
    ],
    colour: 'Saffron',
    number: 9,
    time: '11–1',
  },
  {
    key: 'taurus',
    glyph: '♉',
    name: 'Taurus · Vrishabha',
    rating: 4,
    stats: [
      { label: 'Love', value: 74 },
      { label: 'Career', value: 66 },
      { label: 'Health', value: 88 },
      { label: 'Finance', value: 92 },
    ],
    colour: 'White',
    number: 6,
    time: '2–4',
  },
  {
    key: 'gemini',
    glyph: '♊',
    name: 'Gemini · Mithuna',
    rating: 3.5,
    stats: [
      { label: 'Love', value: 60 },
      { label: 'Career', value: 85 },
      { label: 'Health', value: 72 },
      { label: 'Finance', value: 64 },
    ],
    colour: 'Green',
    number: 5,
    time: '10–12',
  },
  {
    key: 'cancer',
    glyph: '♋',
    name: 'Cancer · Karka',
    rating: 4,
    stats: [
      { label: 'Love', value: 91 },
      { label: 'Career', value: 62 },
      { label: 'Health', value: 77 },
      { label: 'Finance', value: 70 },
    ],
    colour: 'Silver',
    number: 2,
    time: '7–9',
  },
  {
    key: 'leo',
    glyph: '♌',
    name: 'Leo · Simha',
    rating: 5,
    stats: [
      { label: 'Love', value: 78 },
      { label: 'Career', value: 95 },
      { label: 'Health', value: 84 },
      { label: 'Finance', value: 81 },
    ],
    colour: 'Gold',
    number: 1,
    time: '9–11',
  },
  {
    key: 'virgo',
    glyph: '♍',
    name: 'Virgo · Kanya',
    rating: 4,
    stats: [
      { label: 'Love', value: 65 },
      { label: 'Career', value: 88 },
      { label: 'Health', value: 90 },
      { label: 'Finance', value: 73 },
    ],
    colour: 'Emerald',
    number: 5,
    time: '1–3',
  },
  {
    key: 'libra',
    glyph: '♎',
    name: 'Libra · Tula',
    rating: 4.5,
    stats: [
      { label: 'Love', value: 89 },
      { label: 'Career', value: 76 },
      { label: 'Health', value: 70 },
      { label: 'Finance', value: 83 },
    ],
    colour: 'Rose Pink',
    number: 6,
    time: '3–5',
  },
  {
    key: 'scorpio',
    glyph: '♏',
    name: 'Scorpio · Vrishchika',
    rating: 3.5,
    stats: [
      { label: 'Love', value: 71 },
      { label: 'Career', value: 68 },
      { label: 'Health', value: 62 },
      { label: 'Finance', value: 86 },
    ],
    colour: 'Maroon',
    number: 9,
    time: '4–6',
  },
  {
    key: 'sagittarius',
    glyph: '♐',
    name: 'Sagittarius · Dhanu',
    rating: 4.5,
    stats: [
      { label: 'Love', value: 76 },
      { label: 'Career', value: 82 },
      { label: 'Health', value: 87 },
      { label: 'Finance', value: 69 },
    ],
    colour: 'Yellow',
    number: 3,
    time: '12–2',
  },
  {
    key: 'capricorn',
    glyph: '♑',
    name: 'Capricorn · Makara',
    rating: 4,
    stats: [
      { label: 'Love', value: 58 },
      { label: 'Career', value: 93 },
      { label: 'Health', value: 74 },
      { label: 'Finance', value: 88 },
    ],
    colour: 'Navy Blue',
    number: 8,
    time: '5–7',
  },
  {
    key: 'aquarius',
    glyph: '♒',
    name: 'Aquarius · Kumbha',
    rating: 3.5,
    stats: [
      { label: 'Love', value: 67 },
      { label: 'Career', value: 79 },
      { label: 'Health', value: 81 },
      { label: 'Finance', value: 61 },
    ],
    colour: 'Turquoise',
    number: 8,
    time: '8–10',
  },
  {
    key: 'pisces',
    glyph: '♓',
    name: 'Pisces · Meena',
    rating: 4.5,
    stats: [
      { label: 'Love', value: 94 },
      { label: 'Career', value: 71 },
      { label: 'Health', value: 66 },
      { label: 'Finance', value: 77 },
    ],
    colour: 'Sea Green',
    number: 3,
    time: '6–8',
  },
]
